import getStore from '../store/store';
import RequestStatus from '../store/schema/RequestStatus';
import updateAgendaMailOptionService from '../services/updateAgendaMailOptionService';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
import { orchestrator } from 'satcheljs';
import { setGetCalendarFolderServiceStatus } from 'owa-agenda-mail-option/lib/actions/internalActions';
import {
    saveAgendaMailOption,
    updateAgendaMailDisabledForFolder,
} from '../actions/internalActions';
import {
    updateCalendarMailboxConfiguration,
    setMailboxCalendarConfiguration,
} from 'owa-calendar-configuration';

export default orchestrator(saveAgendaMailOption, async () => {
    // 1. Check if the AgendaMailEnabled option is different from server
    const mailboxCalendarConfiguration = getCalendarConfiguration();
    const newAgendaMailEnabled = getStore().isAgendaMailEnabled;
    if (
        mailboxCalendarConfiguration &&
        newAgendaMailEnabled != mailboxCalendarConfiguration.AgendaMailEnabled
    ) {
        updateCalendarMailboxConfiguration({
            AgendaMailEnabled: newAgendaMailEnabled,
        });
        setMailboxCalendarConfiguration({ AgendaMailEnabled: newAgendaMailEnabled });
    }

    // 2. Check if any calendar folder's AngendaMailDisabled option is different from server
    const { foldersToEnableAgendaMail, foldersToDisableAgendaMail } = updateCalendarFolders();
    if (foldersToEnableAgendaMail.length !== 0 || foldersToDisableAgendaMail.length !== 0) {
        updateAgendaMailOptionService(foldersToEnableAgendaMail, foldersToDisableAgendaMail);
    }

    // 3. Reset the request status to NotInitialized, so subsequential clicks will fetch up-to-date data from server
    setGetCalendarFolderServiceStatus(RequestStatus.NotInitialized);
});

function updateCalendarFolders(): {
    foldersToEnableAgendaMail: string[];
    foldersToDisableAgendaMail: string[];
} {
    const foldersToDisableAgendaMail = [];
    const foldersToEnableAgendaMail = [];

    const agendaMailDisabledMap = getStore().agendaMailDisabledMap;
    const calendarFolders = getStore().serverCalendarFolders;

    calendarFolders.forEach(folder => {
        const folderId = folder.FolderId.Id;
        const newAgendaDisabledValue = agendaMailDisabledMap.get(folderId);
        if (newAgendaDisabledValue !== folder.AgendaMailDisabled) {
            // Update local client folder.AgendaMailDisabled value
            updateAgendaMailDisabledForFolder(folder, newAgendaDisabledValue);

            if (newAgendaDisabledValue) {
                // If the new value is to disable agenda mail, add folderId to the disable list
                foldersToDisableAgendaMail.push(folderId);
            } else {
                // Otherwise if it is to enable agenda mail, add folder to the enable list
                foldersToEnableAgendaMail.push(folderId);
            }
        }
    });

    return { foldersToEnableAgendaMail, foldersToDisableAgendaMail };
}
